import React, {
} from 'react';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  defaultCardId: String,
  paymentMethods?: any[],
  onDelete: { (method: any): void },
  onSetDefault: { (method: any): void },
};

const CardsList = ({
  defaultCardId,
  paymentMethods,
  onDelete,
  onSetDefault,
}: Props) => (
  <>
    {paymentMethods?.map(method => (
      <Flex
        key={method.id}
        justify="space-between"
        width="100%"
        padding="10px"
        align="center"
      >
        <Flex
          spacing={10}
          align="center"
        >
          <S.CardIcon
            brand={method.card.brand}
          />
          <Text>
            {method.card.last4}
            ,
          </Text>
          <Text>
            {method.card.exp_month}
            /
            {method.card.exp_year}
          </Text>
        </Flex>
        <Flex align="center">
          <Text>{method.billing_details?.name}</Text>

          {(paymentMethods.length > 1 && defaultCardId !== method.id) && (
            <S.MakeDefaultButton
              onClick={() => onSetDefault(method)}
            >
              Make Default
            </S.MakeDefaultButton>
          )}

          <S.DeleteButton
            onClick={() => onDelete(method)}
          >
            delete
          </S.DeleteButton>
        </Flex>
      </Flex>
    ))}
  </>
);

CardsList.defaultProps = {
  paymentMethods: [],
};

export default CardsList;
